import { useCallback, useReducer, useState } from "react";
import axios from "axios";
import AccountReducer from "./Account.reducer";
import ActionTypes from "../Action.types";
import { Account } from "../../types/Types";

const INITIAL_STATE = {
  accounts: [],
  isLoading: false,
  errMessage: "",
};

const AccountHooks = () => {
  const [state, dispatch] = useReducer(AccountReducer, INITIAL_STATE);
  const [accLength, setAccLength] = useState(0);

  // ------------------------------------------------------------------- //
  // ----------------------------- FIND ALL----------------------------- //
  // ------------------------------------------------------------------- //

  const fetchAccounts = useCallback(async () => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    dispatch({ type: ActionTypes.start, payload: "" });
    try {
      const res: any = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/accounts?userId=${userData.id}`
      );

      dispatch({ type: ActionTypes.find, payload: res.data });
    } catch (err: any) {
      if (err.response) {
        console.log(err.response.data.message);
      } else {
        console.log(err.message);
      }
    }
  }, []);

  const fetchByStatusAndType = useCallback(
    async (
      accStatus: string,
      accType: string,
      pageSize: number,
      skipAcc: number
    ) => {
      dispatch({ type: ActionTypes.start, payload: "" });

      try {
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/accounts/getByStatusAndType?status=${accStatus}&type=${accType}&userId=${userData.id}&skipAcc=${skipAcc}&limitAcc=${pageSize}`
        );
        setAccLength(res.data.length);

        console.log(res.data)

        dispatch({ type: ActionTypes.find, payload: res.data.accounts });
      } catch (err: any) {
        if (err.response) {
          console.log(err.response.data.message);
        } else {
          console.log(err.message);
        }
      }
    },
    []
  );

  const fetchAccountsByDate = useCallback(
    async (startDate: Date, endDate: Date) => {
      dispatch({ type: ActionTypes.start, payload: "" });

      try {
        const setHoursStartDate = new Date(
          new Date(startDate).setHours(0, 0, 0)
        );
        const setHoursEndDate = new Date(
          new Date(endDate).setHours(23, 59, 59)
        );

        const res: any = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/accounts/getByDate/startDate=${setHoursStartDate}&endDate=${setHoursEndDate}`
        );

        dispatch({ type: ActionTypes.find, payload: res.data });
      } catch (err: any) {
        if (err.response) {
          console.log(err.response.data.message);
        } else {
          console.log(err.message);
        }
      }
    },
    []
  );

  const searchAccount = async (search: string) => {
    dispatch({ type: ActionTypes.start, payload: "" });
    try {
      const res: any = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/accounts/getBySearch?search=${search}`
      );

      dispatch({ type: ActionTypes.find, payload: res.data });
    } catch (err: any) {
      if (err.response) {
        console.log(err.response.data.message);
      } else {
        console.log(err.message);
      }
    }
  };
  // ------------------------------------------------------------------ //
  // ----------------------------- UPLOAD ----------------------------- //
  // ------------------------------------------------------------------ //

  const uploadAccounts = (getData: []) => {
    try {
      dispatch({ type: ActionTypes.upload, payload: getData });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ----------------------------------------------------------------------- //
  // ----------------------------- UPDATE ---------------------------------- //
  // ----------------------------------------------------------------------- //

  const editAccount = async (account: Account) => {
    try {
      dispatch({ type: ActionTypes.update, payload: account });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ----------------------------------------------------------------------- //
  // ----------------------------- UPDATE MANY ----------------------------- //
  // ----------------------------------------------------------------------- //

  const editManyAccounts = (itemsId: string[], editData: Account) => {
    try {
      dispatch({
        type: ActionTypes.update_many,
        payload: { itemsId, editData },
      });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  const editStockAgent = (itemsId: string[], editData: Account) => {
    try {
      dispatch({
        type: "EDIT_STOCK_AGENT",
        payload: { itemsId, editData },
      });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ------------------------------------------------------------------ //
  // ----------------------------- DELETE ----------------------------- //
  // ------------------------------------------------------------------ //

  const deleteAccount = (itemId: string) => {
    try {
      dispatch({ type: ActionTypes.delete, payload: itemId });
    } catch (err: any) {
      console.log(err.message);
    }
  };
  // ----------------------------------------------------------------------- //
  // ----------------------------- DELETE MANY ----------------------------- //
  // ---------------------------------------------------------------------- //
  const deleteManyAccounts = (itemsId: string[]) => {
    try {
      dispatch({ type: ActionTypes.delete_many, payload: itemsId });
    } catch (err: any) {
      console.log(err.message);
    }
  };
  // ----------------------------- CLEAR ----------------------------- //
  const clear = () => {
    try {
      dispatch({ type: ActionTypes.clear, payload: "" });
    } catch (err: any) {
      console.log(err.message);
    }
  };
  return {
    state,
    fetchAccounts,
    uploadAccounts,
    editAccount,
    editManyAccounts,
    deleteAccount,
    deleteManyAccounts,
    clear,
    editStockAgent,
    fetchByStatusAndType,
    fetchAccountsByDate,
    searchAccount,
    accLength,
  };
};

export default AccountHooks;
